import "./index.css";
import { clsx } from "clsx";
import { Text } from "../Text";
import type { IMessageProps } from "./types";

export const Message = ({
  text,
  color = "neutral",
  className,
  ref,
}: IMessageProps) => {
  const messageClass: string = clsx(
    "nuco-message",
    `nuco-color-${color}`,
    className,
  );

  // Errors and warnings interrupt; other messages are announced politely.
  const role = color === "danger" || color === "warning" ? "alert" : "status";

  return (
    <Text as="p" ref={ref} className={messageClass} role={role}>
      {text}
    </Text>
  );
};
